import moment from 'moment-timezone';

export const strongPasswordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const setLocalStorage = (key: string, value: string) => {
  try {
    // Validate key and value
    if (!key || typeof key !== 'string') {
      console.warn('Invalid localStorage key');
      return;
    }
    return localStorage.setItem(key, value);
  } catch (error) {
    console.error('Error setting localStorage:', error);
  }
};

/**
 * Securely get item from localStorage
 */
export const getLocalStorage = (key: string) => {
  try {
    if (!key || typeof key !== 'string') {
      return null;
    }
    return localStorage.getItem(key);
  } catch (error) {
    console.error('Error getting localStorage:', error);
    return null;
  }
};

export const removeLocalStorage = (key: string) => {
  try {
    return localStorage.removeItem(key);
  } catch (error) {
    console.error('Error removing localStorage:', error);
  }
};

export const removeAllLocalStorage = () => {
  try {
    return localStorage.clear();
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
};

export const clearLocalStorage = () => {
  try {
    return localStorage.clear();
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
};

export const dateFilter = (date: Date): string => {
  return date.toLocaleDateString('en-us').replace(/\//g, '-');
};

export const camelCaseToNormal = (text: string) => {
  return text
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space before capital letters
    .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
};

export const dateFormat = (date: string, format?: string) => {
  const dateFormat = format ? format : 'YYYY-MM-DD HH:mm:ss';
  return moment.tz(date, 'America/Los_Angeles').format(dateFormat);
};

export const colorCodes = [
  // --- Original color codes ---
  '#FF5733', '#33B5FF', '#8D33FF', '#33FF57', '#FFC133', '#FF33A8', '#33FFF5', '#FF3333',
  '#85FF33', '#3380FF', '#FF8333', '#DA33FF', '#33FF8D', '#FFD633', '#33FFB5', '#B533FF',
  '#33FFD6', '#FF3357', '#337BFF', '#FF3E33', '#33FF57', '#FF33A8', '#33FFF5', '#FF3333',
  '#85FF33', '#3380FF', '#FF8333', '#DA33FF', '#33FF8D', '#FFD633', '#33FFB5', '#B533FF',
  '#33FFD6', '#FF3357', '#337BFF', '#FF3E33', '#33FF57', '#FF33A8', '#33FFF5', '#FF3333',
  '#85FF33', '#3380FF', '#FF8333', '#DA33FF', '#33FF8D', '#FFD633', '#33FFB5',

  // --- New unique color codes (not in original list) ---
  '#FF6F61', '#4BFF33', '#33FFF0', '#FF33F6', '#33A1FF', '#7D33FF', '#33FF99',
  '#FF9933', '#33FFCC', '#FF336E', '#33A8FF', '#FF573D', '#39FF33', '#33FFDA',
  '#FF33B8', '#33B8FF', '#FFE733', '#8E33FF', '#33FF70', '#FF8C33', '#33FFF9',
  '#FF33C4', '#33BFFF', '#9C33FF', '#33FFAE', '#FF5C33', '#33FFE0', '#FF33DE'
];
